import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import DynamicSectionForm from '../../../DynamicSectionForm'
import { DynamicSectionFormValues } from '../../../DynamicSectionForm/components/FormSchema'
import useMutationCreateDynamicSection from '@/modules/client-setting/api/hooks/useMutationCreateDynamicSection'

export default function CreateDynamicSectionForm() {
	const navigate = useNavigate()

	const { mutate: createDynamicSection } = useMutationCreateDynamicSection({
		onSuccess: () => {
			toast.success('สร้าง Section สำเร็จ')
			navigate('/operator/dynamic-section')
		},
		onError: (error) => {
			const errorMessage = error?.response?.data?.message || error?.message

			if (errorMessage === 'Dynamic section name already exists') {
				showErrorToast('ชื่อนี้ถูกสร้างไปแล้ว')
			} else {
				showErrorToast(errorMessage || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
			}
		},
	})

	const handleSubmit = (values: DynamicSectionFormValues) => {
		const payload = {
			...values,
			lottoAnnouncementSection: values.lottoAnnouncementSection
				? {}
				: undefined,
			leaderboardSection: values.leaderboardSection
				? {
						...values.leaderboardSection,
						limit: values.leaderboardSection.limit ?? 5,
					}
				: undefined,
			gameSuggestionSection: values.gameSuggestionSection
				? {
						...values.gameSuggestionSection,
						limit: values.gameSuggestionSection.limit ?? 6,
					}
				: undefined,
			footballMatchesSection: values.footballMatchesSection
				? {
						...values.footballMatchesSection,
						gameId: values.footballMatchesSection.gameId || undefined,
					}
				: undefined,
		}
		createDynamicSection({ payload })
	}

	return <DynamicSectionForm mode="create" onSubmit={handleSubmit} />
}
